import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { ConstMapping, SVGFC } from '@repo/toolkit/types'

import { HappyFaceIcon, NormalFaceIcon, SadFaceIcon } from '../../icons'

/** face evaluation variant */
export type FacesEvaluationVariantType = 'happy' | 'normal' | 'sad'

/** face evaluation map */
export const facesEvaluationMapping: ConstMapping<
  FacesEvaluationVariantType,
  { icon: SVGFC; color: string }
> = {
  happy: {
    label: 'Happy',
    value: 'HAPPY',
    icon: HappyFaceIcon,
    color: tailwindColors.green.DEFAULT
  },
  normal: {
    label: 'Normal',
    value: 'NORMAL',
    icon: NormalFaceIcon,
    color: tailwindColors.secondary.DEFAULT
  },
  sad: {
    label: 'Sad',
    value: 'SAD',
    icon: SadFaceIcon,
    color: tailwindColors.red.DEFAULT
  }
}

export interface FacesEvaluationProps {
  /** face evaluation variants */
  variant: FacesEvaluationVariantType

  onClick?: (data: FacesEvaluationVariantType) => void
}

/**
 * usage
 *
 * ```tsx
 *
 * import FacesEvaluation from "@repo/ui/faces-evaluation";
 *
 * export default function HomePage() {
 *  return (
 *   <FacesEvaluation variant={"happy"} />
 *  )
 * }
 * ```
 */
function FacesEvaluation({ variant, onClick }: FacesEvaluationProps) {
  return (
    <div className={'flex flex-row items-center gap-[7px]'}>
      {Object.entries(facesEvaluationMapping).map(([key, item]) => {
        const Icon = item.icon

        return (
          <div
            key={key}
            className={'rounded-sm p-1 w-7 h-7 flex items-center justify-center'}
            onClick={(e) => {
              e.stopPropagation()
              onClick?.(key as FacesEvaluationVariantType)
            }}
            style={{
              backgroundColor: variant === key ? item.color : tailwindColors.white.active
            }}
          >
            <Icon
              color={
                variant === key ? tailwindColors.white.DEFAULT : tailwindColors.grey.light.active
              }
            />
          </div>
        )
      })}
    </div>
  )
}

export default FacesEvaluation
